import React from "react";
import { commingSoon } from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";

function RmsAlert() {
  return (
    <>
      <div className="block1 alert-table">
        <div className="card-title">
          <h2>{Constants.Rms_Alert}</h2>
        </div>
        {/* <div className="scroll-table">
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">Exchange</th>
                                <th scope="col">Script</th>
                                <th scope="col">Quantity</th>
                                <th scope="col">Client Code</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                            </tr>
                            <tr>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                            </tr>
                            <tr>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                            </tr>
                            <tr>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                            </tr>
                            <tr>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                            </tr>
                            <tr>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                            </tr>
                            <tr>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                            </tr>
                            <tr>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                            </tr>
                            <tr>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                            </tr>
                            <tr>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                                <td>lorem ipsum</td>
                            </tr>
                        </tbody>
                    </table>
                </div> */}
        {commingSoon()}
      </div>
    </>
  );
}

export default RmsAlert;
